import { useHasModulePermissions } from '@/permissions/useModulePermissions';
import { t } from '@lingui/macro';
import { CollapsibleSidebar, CollapsibleSidebarItem } from '@luminovo/design-system';
import { CalculateOutlined, FactoryOutlined, TravelExploreRounded } from '@mui/icons-material';
import { route } from '../../utils/routes';

export function CostingTemplatesSidebar() {
    let isAuthorizedForManufacturing = useHasModulePermissions({
        requiredPermissions: { module: 'manufacturing', permission: 'manage' },
    });

    let contents: Array<CollapsibleSidebarItem> = [
        {
            type: 'link',
            href: route('/sourcing-templates'),
            Icon: TravelExploreRounded,
            label: t`Sourcing`,
            isSelected: (pathname) => pathname.startsWith('/sourcing-templates'),
        },
        {
            type: 'link',
            href: route('/calculation/templates'),
            Icon: CalculateOutlined,
            label: t`Calculation`,
        },
    ];
    if (isAuthorizedForManufacturing) {
        contents.push({
            type: 'link',
            href: route('/manufacturing/activity'),
            Icon: FactoryOutlined,
            label: t`Manufacturing`,
            isSelected: (pathname) => pathname.startsWith('/manufacturing/'),
        });
    }
    return <CollapsibleSidebar id="costing-templates" title={t`Costing templates`} contents={contents} />;
}
